import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import {  Autoplay , Navigation, Pagination  ,EffectFade} from 'swiper/modules';

function testimonialblock() {
    const testimonial_slider = document.querySelector('[data-target="testimonial_slider"]');
    if (!testimonial_slider) { return; }
    const testimonial_pagination = testimonial_slider.querySelector('.swiper-pagination-vertical')
    const testimonial_nav_next = testimonial_slider.querySelector('.swiper-button-next')
    const testimonial_nav_prev = testimonial_slider.querySelector('.swiper-button-prev')


   

    let timeline_testimonialintro = gsap.timeline({
        scrollTrigger: {
        trigger: testimonial_slider,
        start: 'top 80%',
        end:"+=80%",
        scrub:true
        }
    });

    timeline_testimonialintro.fromTo("[data-target='testimonial_slider_img']", { autoAlpha:0}, {duration:1, autoAlpha:1}, "start") 
    .fromTo([testimonial_pagination,testimonial_nav_prev, testimonial_nav_next ], { autoAlpha:0}, {duration:1, autoAlpha:1}, "start") 
    .fromTo("[data-target='testimonial_slider_box']", { x:"+=200px"}, {duration:1.5, x:0}, "-.5" ) 
    .fromTo("[data-target='testimonial_slider_box'] p", { autoAlpha:0},{duration:1.5, autoAlpha:1}, "-=1") 



    const slider = new Swiper(testimonial_slider, {
        modules: [Pagination, Autoplay, Navigation,EffectFade],
        loop: true,
        draggable: true,
        allowTouchMove: true,
        spaceBetween: 20,
        slidesPerView: 1,
        speed:1000,
        effect: 'fade',
        //autoHeight:true,
        // autoplay: {
        //     delay: 4000,
        // },
        pagination: {
            el: testimonial_pagination,
            clickable: true,
        },
        navigation: {
            nextEl: testimonial_nav_next,
            prevEl: testimonial_nav_prev,
          },

          on: {
            slideChange: function () {
                
               
                // const slides = document.querySelectorAll("[data-target='testimonial_slider'] .swiper-slide");
                // const testimonial_slider_img_next = slides[next].querySelector("[data-target='testimonial_slider_img']");
                // const testimonial_slider_img_prev = slides[prev].querySelector("[data-target='testimonial_slider_img']");

                // gsap.to(testimonial_slider_img_prev, {autoAlpha:0, duration:5})
                // gsap.set([testimonial_slider_img_next], {autoAlpha:0})
                
                
            },
            slideChangeTransitionStart: function () {
                var activeIndex = this.activeIndex; 

                var next = this.activeIndex
                
                var prev = this.previousIndex
                
                const slides = document.querySelectorAll("[data-target='testimonial_slider'] .swiper-slide");
                const activetestimonial_slider_img = slides[activeIndex].querySelector("[data-target='testimonial_slider_img']");
                const prevtstimonial_slider_img = slides[prev].querySelector("[data-target='testimonial_slider_img']");

                const activetestimonial_slider_box = slides[activeIndex].querySelector("[data-target='testimonial_slider_box']");
                const activetestimonial_slider_box_p = activetestimonial_slider_box.querySelectorAll("p");
                const prevtestimonial_slider_box = slides[prev].querySelector("[data-target='testimonial_slider_box']");
                const prevtestimonial_slider_box_p = prevtestimonial_slider_box.querySelectorAll("p");


               

                var tl_slide_out = gsap.timeline({});
                tl_slide_out.to(prevtestimonial_slider_box_p, {autoAlpha:0,duration:.5})
                .to(prevtstimonial_slider_img, {autoAlpha:0, duration:.5})
                //.to(prevtestimonial_slider_box, {scaleX:0.5, duration:1.5},"-=0.4")
                
                

                var tl_slide_in = gsap.timeline({delay:0});
                tl_slide_in.fromTo(activetestimonial_slider_img, { autoAlpha:0}, {duration:.5, autoAlpha:1}) 
                .fromTo(activetestimonial_slider_box, { scaleX:0.5}, {duration:1.5, scaleX:1}, "-.3") 
                .fromTo(activetestimonial_slider_box_p, { autoAlpha:0},{duration:.5, autoAlpha:1}) 
                
               

                if (tl_slide_in && tl_slide_in.isActive()) {
                    tl_slide_in.kill();
                }
                if (tl_slide_out && tl_slide_out.isActive()) {
                    tl_slide_out.kill();
                }

            },
            transitionEnd: function () {
                
                // var activeIndex = this.realIndex; 
                // console.log(activeIndex);

                
                // const slides = document.querySelectorAll("[data-target='testimonial_slider'] .swiper-slide");
                // const activetestimonial_slider_img = slides[activeIndex].querySelector("[data-target='testimonial_slider_img']");
                
                // gsap.to(activetestimonial_slider_img, {duration:.5, autoAlpha:1, delay:.2})
               
             

             },
             beforeTransitionStart: function () {
                
                var activeIndex = this.realIndex; 
               
               


             },
             init: function () {
               

               
             }

             

            
            
        },


    });
 
      
}


export { testimonialblock }; 